import { publicUrlFor } from "../constants";

function FastImage(props) {
    // Extract loading prop, default to 'lazy' for performance
    const { loading = 'lazy', ...restProps } = props;
    
    return (
        <>
            <img 
                {...restProps} 
                src={publicUrlFor(props.src)} 
                alt={props.alt}
                loading={loading}
                decoding="async"
            />
        </>
    )
}
export default FastImage;